import type { IPaymentConfigurationInput, ValidationSchema } from "..";

export const schemaPaymentConfiguration: ValidationSchema<IPaymentConfigurationInput> =
    {
        name: { required: true },
    };
